import React, {useState} from 'react';
import {request} from '../../utils/api';

const FileSave = ({component, onFileSave, labelId}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onFileChange = ({
    target: {
      validity,
      files: [file],
    },
  }) => {
    if (validity.valid) {
      setLoading(true);
      setError(null);
      const form = new FormData();
      form.append('path', file);
      request({method: 'post', url: '/api/files', data: form, headers: {'Content-Type': 'multipart/form-data'}})
        .then(res => {
          onFileSave(res.data);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          setError(e.response.data);
        });
    }
  };

  return (
    <div id="FileSave">
      <label className="d-block m-0" htmlFor={`${labelId || 'file'}-upload`} style={{cursor: 'pointer'}}>
        {component(loading, error && error.path)}
      </label>
      <input id={`${labelId || 'file'}-upload`} type="file" className="d-none" onChange={onFileChange} />
    </div>
  );
};

export default FileSave;
